import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface CampaignDetail {
  campaign_name: string;
  total_minutes: number;
}

@Component({
  selector: 'app-drilldown-modal',
  templateUrl: './drilldown-modal.component.html',
  styleUrls: ['./drilldown-modal.component.scss']
})
export class DrilldownModalComponent implements OnInit {

  @Input() organizationName: string = '';
  @Input() month: string = '';
  @Input() drillDownData: CampaignDetail[] = [];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    console.log("Drilldown modal initialized for:", this.organizationName, this.month);
  }

  get totalMinutes(): number {
    if (!this.drillDownData || this.drillDownData.length === 0) {
      return 0;
    }
    return this.drillDownData.reduce((sum, item) => sum + (Number(item.total_minutes) || 0), 0);
  }

  formatMinutes(minutes: number | undefined | null): string {
    return (Number(minutes) || 0).toFixed(2);
  }

  closeModal(): void {
    this.activeModal.close('Close button clicked');
  }

  dismissModal(): void {
    this.activeModal.dismiss('Dismiss button clicked');
  }
}
